import { useEffect, useState, useMemo } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { connect } from 'react-redux'
import { StripeActions } from 'store/actions'
import toast from 'react-hot-toast'
import { PortalSpinner } from 'components/PortalSpinner'
import CheckoutForm from 'components/StripeElement/CheckoutForm'
import { capitalize } from 'lodash';
import { appearance } from './helper'

let enhancer = connect(null, { ...StripeActions })

const StripeElement = ({ resource, createClientSecrete, validateStripeAccount, onSuccess }) => {
  const [clientSecret, setClientSecret] = useState(null)
  const [stripeConfig, setStripeConfig] = useState(null)

  const stripePromise = useMemo(() => {
    if (!stripeConfig) return null

    const { stripe_account_id, stripe_publishable_key } = stripeConfig

    return loadStripe(stripe_publishable_key,
      {
        stripeAccount: stripe_account_id,
        developerTools: { assistant: { enabled: false } }
      })
  }, [stripeConfig])

  useEffect(() => {
    loadStripeData()
  }, [resource])

  const loadStripeData = async () => {
    try {
      const { data } = await validateStripeAccount({ account_type: 'standard' })
      const { client_secret } = await createClientSecrete(resource)

      setStripeConfig(data.attributes)
      setClientSecret(client_secret)

    } catch (error) {
      setClientSecret({ hasError: true, error: error.errors || 'Failed to load payment form Try again later' })
      toast.error(error.errors || 'Failed to load payment form')
    }
  }

  if (clientSecret?.hasError)
    return (
      <div className="w-full space-y-6 py-4">
        <p className="text-red-500 text-center">{capitalize(clientSecret?.error)}</p>
      </div>
    )

  if (!clientSecret || !stripePromise) return <PortalSpinner />

  return (
    <div className="w-full space-y-6 py-4">
      <Elements stripe={stripePromise} options={{ clientSecret, appearance }}>
        <div className="w-full max-w-4xl mx-auto">
          <CheckoutForm
            onSuccess={onSuccess}
            clientSecret={clientSecret}
          />
        </div>
      </Elements>
    </div>
  )
}

export default enhancer(StripeElement)
